import { render, staticRenderFns } from "./SignupButton.vue?vue&type=template&id=aa36825c&scoped=true&"
import script from "./SignupButton.vue?vue&type=script&lang=ts&"
export * from "./SignupButton.vue?vue&type=script&lang=ts&"
import style0 from "./SignupButton.vue?vue&type=style&index=0&id=aa36825c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa36825c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('aa36825c', component.options)
    } else {
      api.reload('aa36825c', component.options)
    }
    module.hot.accept("./SignupButton.vue?vue&type=template&id=aa36825c&scoped=true&", function () {
      api.rerender('aa36825c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/header/SignupButton.vue"
export default component.exports